"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSummary = getSummary;
async function getSummary(orderRepo, filters = '', startDate = '', endDate = '', machineIds = [], clubIds = []) {
    return await orderRepo.getSummary(filters, startDate, endDate, machineIds, clubIds);
}
